export function activateDeferredLinks() {
  /**
   * @type {NodeListOf<HTMLAnchorElement>}
   */
  const deferredLinks = document.querySelectorAll('a[data-deferred-link]');

  deferredLinks.forEach((link) => {
    link.onclick = (event) => {
      event.preventDefault();
      event.stopPropagation();
      const url = link.getAttribute('data-deferred-link');
      window.open(url, '_blank');
    };
    link.href = 'javascript:void(0)';
  });
}
